// extracted by mini-css-extract-plugin
module.exports = {"navBody":"MyNavigationBar_navBody__fM8Ie","navGradient":"MyNavigationBar_navGradient__3vUbS"};